import { render, staticRenderFns } from "./system-configuration.vue?vue&type=template&id=98d127ce&scoped=true&"
import script from "./system-configuration.vue?vue&type=script&lang=js&"
export * from "./system-configuration.vue?vue&type=script&lang=js&"
import style0 from "./system-configuration.vue?vue&type=style&index=0&id=98d127ce&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d127ce",
  null
  
)

export default component.exports